export const SIGN_UP = '/signup';
export const PASSWORD_FORGET = '/pw-forget';
export const HOME = '/';
export const PROFILE = '/profile';
export const CUSTOMER_ACCEPT = '/customers/join/:token';